<template>
  <b-row>
    <b-modal
      id="sent-files"
      header-class="anchor-modal"
      title="Bank Statement - Upload Files"
      v-model="showModal"
      hide-footer
      @hidden="$emit('close', true)"
      :no-close-on-backdrop="modalNoCloseOnBackdrop"
      :no-close-on-esc="modalNoCloseOnEsc"
      :hide-header-close="modalHideHeaderClose"
    >
      <div class="col-12" v-if="prior2Months">
        <b-row>
          <b-col class="text-center text-small">
            We require complete bank statements for the last two months.
            <hr/>
          </b-col>
        </b-row>
      </div>
      <b-row
        v-for="(model, index) in dates"
        :key="index"
        :class="{ 'mt-3': index !== 0 }"
      >
        <b-col>
          <vue-form-generator
            :schema="schema"
            :model="model"
          />
          <b-row>
            <b-col v-if="prior2Months" class="text-left">
              <upload
                v-if="model.date"
                class="mx-0"
                @files-changed="clearErrors"
                @success="onSuccess"
                :ref="`prior2MonthsUpload${index}`"
                :showSubmitButton="false"
                :multiple="false"
                :startUpload="startUpload"
              />
            </b-col>
            <b-col v-else>
              <upload
                v-if="model.date"
                class="mx-0"
                @success="onSuccess"
                @upload="uploadStart"
                @cancel="cancel"
                :url-upload="`/users/${user.id}/docs`"
                :multiple="false"
                :params="{ type: 'Bank Statement', doc_date: model.date }"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="col-12">
        <error-display :errors="errors" show-divider />
        <submit-button
          v-if="prior2Months && startUploadInternalTimer === 0"
          title="Submit"
          :class="{ 'mt-2': !errors.length }"
          @submit="sendAllDocuments"
        />
      </div>
      <cancel-upload
        v-if="showCancelUploadButton"
        @cancel="cancel"
      >
      </cancel-upload>
    </b-modal>
  </b-row>
</template>

<script>
import helper from '@/libs/forms';
import CancelUpload from '@/components/utils/upload/CancelUpload';
import ErrorDisplay from '@/components/utils/ErrorDisplay';
import SubmitButton from '@/components/utils/buttons/form/SubmitButton';
import { RELEASE_INTERFACE } from '@/vuex/types/actions';
import Upload from '@/components/utils/upload/Upload';
import uploadValidatorMixin from '@/components/utils/upload/uploadValidatorMixin';


export default {
  name: 'BankStatementDocuments',
  mixins: [uploadValidatorMixin],
  components: {
    Upload,
    CancelUpload,
    ErrorDisplay,
    SubmitButton,
  },
  data() {
    return {
      showModal: false,
      schema: { fields: [helper.date('Document Date', null, 'date', true, null, '', false, true)] },
      dates: this.getSingleDate(),
      prior2Months: false,
      modalNoCloseOnBackdrop: false,
      modalNoCloseOnEsc: false,
      modalHideHeaderClose: false,
      timeThresholdToCancelUpload: 30,
      startUploadInternalTimer: 0,
      showCancelUploadButton: false,
      startUpload: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    getSingleDate() {
      return [{ date: null }];
    },
    validatePackage(data) {
      const keys = Object.keys(data);
      const noEmptyKey = keys.every(key => (!!data[key]));
      const packageHasData = keys.length !== 0 && noEmptyKey;
      if (!packageHasData) {
        this.errors = ['All fields are required.'];
      }

      const allFilesValid = ['file1', 'file2'].every(key => this.validate(data[key]));
      return packageHasData && allFilesValid;
    },
    sendAllDocuments() {
      this.errors = [];
      this.uploadStart();
      let data = {};
      try {
        data = {
          type: 'Bank Statement',
          file1: this.$refs.prior2MonthsUpload0[0].files[0],
          file2: this.$refs.prior2MonthsUpload1[0].files[0],
          file1Date: this.dates[0].date,
          file2Date: this.dates[1].date,
        };
      } catch (_) { /* Validation bellow will handle cases when an error happens here */ }

      if (!this.validatePackage(data)) { return; }

      this.$reqs.upload(`/users/${this.user.id}/bank_statement_package`, data, this.onUploading)
        .then(() => {
          this.onSuccess();
        })
        .catch(() => {});
    },
    onUploading() {
      const elapsedTime = (Date.now() - this.startUploadInternalTimer) / 1000;
      if (elapsedTime > this.timeThresholdToCancelUpload) {
        this.showCancelUploadButton = true;
        this.$store.dispatch(RELEASE_INTERFACE);
      }
    },
    open(files) {
      this.prior2Months = files.length === 0;
      if (this.prior2Months) {
        const today = new Date();
        this.dates = [0, 1].map((val) => {
          const date = new Date();
          date.setMonth(today.getMonth() - val);
          return { date: date.toLocaleDateString('en') };
        });
      } else {
        this.dates = this.getSingleDate();
      }

      // initialize all variables
      this.showCancelUploadButton = false;
      this.modalNoCloseOnBackdrop = false;
      this.modalNoCloseOnEsc = false;
      this.modalHideHeaderClose = false;
      this.startUpload = false;
      this.startUploadInternalTimer = 0;
      this.showModal = true;
    },
    close() {
      this.dates = this.getSingleDate();
      this.showModal = false;
    },
    onSuccess() {
      this.close();
      this.$emit('success');
    },
    uploadStart() {
      this.startUploadInternalTimer = Date.now();
      this.startUpload = true;
      this.modalNoCloseOnBackdrop = true;
      this.modalNoCloseOnEsc = true;
      this.modalHideHeaderClose = true;
    },
    cancel() {
      this.$reqs.cancelUploadRequest();
      this.showModal = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/documents/BankStatementUpload.vue